<div class="offers-actions" [class.no-offers]="noOffers">
    <div class="new-theme-typography">
        <span class="mat-body-1" *ngIf="noOffers">
            This application has no offers or contracts.
        </span>
    </div>
    <div class="flex flex-row items-center gap-4">
        <button mat-button
                class="lendio-mat-button-small add-offer-link"
                (click)="openMakeOfferDialog(true)">
            <span>Add offer link</span>
        </button>
        <button mat-flat-button
                class="lendio-mat-button-small"
                color="primary"
                (click)="openMakeOfferDialog(false)">
            <span>Add offer</span>
        </button>
    </div>
</div>
<ng-container *ngIf="hasOffers">
    <mat-card *ngFor="let offer of offers" appearance="outlined" class="mb-4">
        <mat-card-header>
            <mat-card-title [matTooltip]="offer.name">
                Offer
                <span *ngIf="offer.apiLogId"> - API Generated</span>
                <span class="text-{{ offer.status }}">
                            ({{offer.status}})
                        </span>
                <span *ngIf="offer.type === 'hard'" class="text-warning"
                >Hard Offer</span
                >
            </mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <div *ngIf="offer.borrowerDeclined">
                <div class="panel-body panel-alt-background">
                        <span class="font-bold text-uppercase"
                        >Borrower decline reason:</span
                        >
                    <p>{{ offer.declinedReason }}</p>
                </div>
            </div>

            <div class="panel-body offer-panel-body">
                <div class="grid grid-cols-3 justify-between">
                    <ng-container *ngFor="let field of fieldsToDisplayByType(offer.loanProductCategory, offer.offerLink)">
                        <!-- Amount -->
                        <ng-container *ngIf="field == 'amount'">
                            <div>
                                <span class="col-header">{{ variableFieldName('amount', offer.loanProductCategory)}}</span>
                                <div *ngIf="offer.amount">
                                    {{ offer.amount | currency }}
                                </div>
                                <div *ngIf="!offer.amount">-</div>
                            </div>
                        </ng-container>

                        <!-- Payback -->
                        <ng-container *ngIf="field == 'payback'">
                            <div>
                                <span class="col-header">Payback</span>
                                <div *ngIf="offer.payback">
                                    {{ offer.payback | currency }}
                                </div>
                                <div *ngIf="!offer.payback">-</div>
                            </div>
                        </ng-container>

                        <!-- Factor Rate -->
                        <ng-container *ngIf="field == 'factor'">
                            <div>
                                <span class="col-header">Factor Rate</span>
                                <div *ngIf="offer.factor">
                                    {{ offer.factor | number:'1.2-2' }}
                                </div>
                                <div *ngIf="!offer.factor">-</div>
                            </div>
                        </ng-container>

                        <!-- Interest Rate -->
                        <ng-container *ngIf="field == 'interestRate'">
                            <div>
                                <span class="col-header">Interest Rate</span>
                                <div *ngIf="offer.interestRate">
                                    {{ offer.interestRate | number:'1.0-2' }}%
                                </div>
                                <div *ngIf="!offer.interestRate">-</div>
                            </div>
                        </ng-container>

                        <!-- Num. Payments -->
                        <ng-container *ngIf="field == 'numPayments'">
                            <div>
                                <span class="col-header">Num. Payments</span>
                                <div *ngIf="offer.numPayments">
                                    {{ offer.numPayments }}
                                </div>
                                <div *ngIf="!offer.numPayments">-</div>
                            </div>
                        </ng-container>

                        <!-- Payment Frequency -->
                        <ng-container *ngIf="field == 'paymentFrequency'">
                            <div>
                                <span class="col-header">Payment Frequency</span>
                                <div>
                                    {{
                                        paymentFrequencyDisplay(offer) &&
                                        offer.paymentFrequency !== ""
                                        ? paymentFrequencyDisplay(offer)
                                        : "-"
                                    }}
                                </div>
                            </div>
                        </ng-container>

                        <!-- Payment Amount -->
                        <ng-container *ngIf="field == 'paymentAmount'">
                            <div>
                                <span class="col-header">Payment Amount</span>
                                <div *ngIf="offer.paymentAmount">
                                    {{ offer.paymentAmount | currency }}
                                </div>
                                <div *ngIf="!offer.paymentAmount">-</div>
                            </div>
                        </ng-container>

                        <!-- Term -->
                        <ng-container *ngIf="field == 'term'">
                            <div>
                                <span class="col-header">{{ variableFieldName('term', offer.loanProductCategory)}}</span>
                                <div *ngIf="offer.term">
                                    {{ offer.term + "mo." }}
                                </div>
                                <div *ngIf="!offer.term">-</div>
                            </div>
                        </ng-container>

                        <!-- Date Received -->
                        <ng-container *ngIf="field == 'received'">
                            <div>
                                <span class="col-header">Date Received</span>
                                <div *ngIf="offer.received">
                                    {{
                                        offer.received | toDateObj | date : "shortDate"
                                    }}
                                </div>
                                <div *ngIf="!offer.received">-</div>
                            </div>
                        </ng-container>

                        <!-- Expiration Date -->
                        <ng-container *ngIf="field == 'expiration'">
                            <div>
                                <span class="col-header">Expiration Date</span>
                                <div *ngIf="offer.expiration">
                                    {{
                                        offer.expiration | toDateObj | date : "shortDate"
                                    }}
                                </div>
                                <div *ngIf="!offer.expiration">-</div>
                            </div>
                        </ng-container>

                        <!-- Net Fund Amount -->
                        <ng-container *ngIf="field == 'netFundedAmount'">
                            <div>
                                <span class="col-header">Net Fund Amount</span>
                                <div *ngIf="offer.netFundedAmount">
                                    {{ offer.netFundedAmount | currency }}
                                </div>
                                <div *ngIf="!offer.netFundedAmount">-</div>
                            </div>
                        </ng-container>

                        <!-- Offer Notes -->
                        <ng-container *ngIf="field == 'notes'">
                            <div>
                                <span class="col-header">Offer Notes</span>
                                <div *ngIf="offer.notes">
                                    {{ offer.notes }}
                                </div>
                                <div *ngIf="!offer.notes">-</div>
                            </div>
                        </ng-container>

                        <!-- Advance Rate -->
                        <ng-container *ngIf="field == 'advanceRate'">
                            <div>
                                <span class="col-header">Advance Rate</span>
                                <div *ngIf="offer.advanceRate">
                                    {{ offer.advanceRate }}%
                                </div>
                                <div *ngIf="!offer.advanceRate">-</div>
                            </div>
                        </ng-container>

                        <!-- Min Purchase Fee -->
                        <ng-container *ngIf="field == 'minPurchaseFee'">
                            <div>
                                <span class="col-header">Min Purchase Fee</span>
                                <div *ngIf="offer.minPurchaseFee">
                                    {{ offer.minPurchaseFee }}%
                                </div>
                                <div *ngIf="!offer.minPurchaseFee">-</div>
                            </div>
                        </ng-container>

                        <!-- Commission -->
                        <ng-container *ngIf="field == 'commission'">
                            <div>
                                <span class="col-header">Commission</span>
                                <div *ngIf="offer.commission">
                                    {{ offer.commission | currency }}
                                </div>
                                <div *ngIf="!offer.commission">-</div>
                            </div>
                        </ng-container>

                        <!-- Points -->
                        <ng-container *ngIf="field == 'points'">
                            <div>
                                <span class="col-header">Points</span>
                                <div *ngIf="offer.points">
                                    {{ offer.points }}
                                </div>
                                <div *ngIf="!offer.points">-</div>
                            </div>
                        </ng-container>

                        <!-- Payment Term -->
                        <ng-container *ngIf="field == 'paymentTerm'">
                            <div>
                                <span class="col-header">Payment Term</span>
                                <div *ngIf="offer.paymentTerm" style="text-transform: capitalize">
                                    {{ offer.paymentTerm }}
                                </div>
                                <div *ngIf="!offer.paymentTerm">-</div>
                            </div>
                        </ng-container>

                        <!-- Origination Fee -->
                        <ng-container *ngIf="field == 'originationFee'">
                            <div
                                class="flex-1 p-1 origination-fee-display"
                                (mouseover)="setOriginationFeeToggleDisplay(true)"
                                (mouseleave)="setOriginationFeeToggleDisplay(false)"
                            >
                                <span class="col-header">Origination Fee</span>
                                <div class="origination-fee" *ngIf="offer.originationFee">
                                    <span>
                                        {{
                                            originationDisplayDollars
                                            ? ((offer.originationFee * offer.amount) / 100 | currency)
                                            : offer.originationFee + "%"
                                        }}</span>
                                    <a
                                        *ngIf="displayOriginationToggle"
                                        class="inline-table-toggle"
                                        (click)="toggleOriginationFeeDisplayDollars()"
                                    >
                                        {{
                                            originationDisplayDollars
                                            ? "View %"
                                            : "View " +
                                            localeCurrencySymbol
                                        }}
                                    </a>
                                </div>
                                <div *ngIf="!offer.originationFee">-</div>
                            </div>
                        </ng-container>

                        <!-- Rate Type (based on buyRate) -->
                        <ng-container *ngIf="field == 'rateType'">
                            <div>
                                <span class="col-header">Rate Type</span>
                                <div>
                                    {{ offer.buyRate ? "Buy Rate" : "Sell Rate" }}
                                </div>
                            </div>
                        </ng-container>

                        <!-- Variable Rate (rateTypeName based on buyRate) -->
                        <ng-container *ngIf="field == 'variableRate'">
                            <div>
                                <span class="col-header">{{ rateTypeName(offer) }}</span>
                                <div>
                                    {{ 
                                        rateType(offer)
                                        ? offer.buyRate !== null
                                            ? offer.buyRate
                                            : offer[rateType(offer)]
                                        : "-"
                                    }}
                                    {{
                                        offer[rateType(offer)] !== null
                                        ? rateType(offer) !== "factor"
                                            ? "%"
                                            : ""
                                        : ""
                                    }}
                                </div>
                            </div>
                        </ng-container>

                        <!-- Position -->
                        <ng-container *ngIf="field == 'position'">
                            <div>
                                <span class="col-header">Position</span>
                                <div *ngIf="offer.position">
                                    {{ offer.position }}
                                </div>
                                <div *ngIf="!offer.position">-</div>
                            </div>
                        </ng-container>

                        <!-- Offer Link -->
                        <ng-container *ngIf="field == 'offerLink'">
                            <div>
                                <span class="col-header">Offer link</span>
                                <span
                                    class="icon-16-help"
                                    uib-tooltip="This link directs a Borrower to the Lender’s portal where they will perform final steps to accept their offer. This is a one-time use link, so do not visit this page!"
                                ></span>
                                <div class="long-word-wrap">
                                    <a
                                        data-cy="offerLink"
                                        target="_blank"
                                        href="{{ offer.offerLink }}"
                                    >
                                        {{ offer.offerLink }}
                                    </a>
                                </div>
                            </div>
                        </ng-container>
                    </ng-container>
                </div>
            </div>
        </mat-card-content>

    </mat-card>
</ng-container>
